// 联系工程师
<template>
  <div>
    <Logo></Logo>
	<!-- 页头 -->
	<!-- <Header/> -->
    <div><img :src="image" class="bg"></div>
        <div style="margin-top:4rem;overflow-y:auto;" v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-delay=500>
            <div class="descriptions" v-for="(list,i) in lists">
            <el-card class="box_card">
            <!-- 列表循环驱动，三部分，擅长领域为一部分，图片为一部分，详情为一部分 -->
            <div class="img">
                <el-image  :src="list.avatar?list.avatar:require('../../assets/img/moren.png')" fit style="width: 7.109375rem; "></el-image>
                <div class="text">
                    {{splitStr1(list.name)}}
                </div>
                <div class="text">
                    {{splitStr2(list.name)}}
                </div>
            </div>
            <div style="font-weight:bold">
                擅长领域：<br/>
                <div class="blue">
                    {{ list.domain }}
                </div>
            </div>
			<el-descriptions direction="horizontal" :column='1' v-bind:colon=false class="edescriptions">
                <el-descriptions-item label="联系电话：" class="description">{{list.phone}}</el-descriptions-item>
			    <el-descriptions-item label="固定电话：" class="description">{{list.tel}}</el-descriptions-item>
			    <el-descriptions-item label="传真：" class="description">{{list.fax}}</el-descriptions-item>
			    <el-descriptions-item label="邮箱：" class="description">{{list.email}}</el-descriptions-item>
				<el-descriptions-item label="地址：" class="description">{{list.address}}</el-descriptions-item>
			</el-descriptions>
            </el-card>
		</div>
        </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import api from '@/utils/api'
import Tabbar from '../Index/Index_components/Tabbar.vue'
import Logo from "../Index/Index_components/logo.vue"
export default {

  name: 'contactEngineer',
  components: {
    // Header,
    Tabbar,
    Logo,
  },
  created () {
    if (window.localStorage.getItem('contactImage')) {
      var image1 = JSON.parse(window.localStorage.getItem('contactImage'))
      this.image = image1.data.data.image
    }
    this.getEngineer()
  },

  data () {
    return {
      count: 1,
      lists: [],
      list: [],
      page_count: 0,
      loading: false,
      image: '',
    }
  },
  computed: {
    disabled () {
      return this.loading
    },
    splitStr1: function () {
      //   var str = name
      // console.log(a)
      //   var a = name.split(';')
      //   console.log(a)
      return name => {

        var a = name.split(";")
        // console.log(a)
        return a[0]
      }
    },
    splitStr2: function () {
      //   var str = name
      // console.log(a)
      //   var a = name.split(';')
      //   console.log(a)
      return name => {

        var a = name.split(";")
        // console.log(a)
        return a[1]
      }
    },
  },
  methods: {

    // local () {
    //   var storage = window.localStorage
    //   if (!storage) {
    //     return false
    //   } else {
    //     if (storage.getItem('engineer')) {
    //       var engineer = JSON.parse(storage.getItem('engineer'))
    //       if (engineer.data) {
    //         this.lists = engineer.data
    //       }
    //       if (engineer.image.code === 200) {
    //         this.image = engineer.image.data.image
    //       }
    //       if (new Date().getTime() - engineer.time > 50000) {
    //         storage.removeItem('engineer')
    //       }
    //     } else {
    //       this.getEngineer()
    //     }
    //   }
    // },
    async getEngineer () {
      const { data: data } = await api.getEngineer(this.count)
      //   var currTime = new Date().getTime()
      //   if (image.code === 200) {
      //     this.image = image.data.image
      //   }
      if (data.code === 200) {
        this.list = data.data.results
        this.page_count = data.data.page_count
        this.count++
        this.list.forEach(item => {
          this.lists.push(item)
        })
      }
      //   window.localStorage.setItem('engineer', JSON.stringify({
      //     time: currTime,
      //     data: this.lists,
      //     image:image,
      //     count:this.count
      //   }))
    },
    load () {
      this.loading = true
      //   var str = JSON.parse(window.localStorage.getItem('engineer'))
      //   this.count = str.count
      console.log('进入触底', this.count)
      if (this.count <= this.page_count) {
        console.log('我是触底加载中')
        this.getEngineer()
      }
      this.loading = false
    },
    goBack () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/home' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>
<style scoped>
/* 取消边框 */
/deep/ .el-card__body {
  padding-top: 32px !important;
  padding-left: 24px !important;
}
/deep/ .box_card {
  font-size: 1.5rem !important;
  width: 43.875rem !important;
  /* height: 26.5rem !important; */
  margin-left: 1.5rem !important;
  margin-bottom: 1.5rem;
}
/* 擅长领域字体 */
.blue {
  margin-top: 0.5rem;
  color: #0099da;
  width: 30.625rem;
  height: 4.25rem;
  font-weight: normal;
}
.edescriptions {
  margin-bottom: 2rem;
  margin-top: 1.5rem;
}
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
/deep/ .descriptions {
  width: 43.875rem !important;
  /* height: 26.5rem !important; */
  padding-bottom: 1.5rem !important;
}
/deep/ .description {
  margin-bottom: 0.875rem !important;
  font-size: 1.5rem !important;
  
}
/* 标题字体 */
/deep/ .el-descriptions-item__label {
  color: #666666 !important;
  font-size: 1.5rem !important;
  word-break: keep-all;
}
/deep/ .el-descriptions-item__content {
  color: #333333 !important;
  font-size: 1.5rem !important;
}
/deep/ .img {
  /* width: 7.109375rem; */
  height: 6.83625rem;
  position: absolute;
  margin-left: 32.945rem;
  margin-top: 1.71875rem;
}
/* 图片底下的文字 */
/deep/.text {
  text-align: center;
}


</style>
